import appConfig from "../config/env";
import { buildQueryString } from "./query";
import { logoutExpiredSession } from "./authSession";

/** Skip session teardown on POST /auth/login (wrong password → 401). */
function shouldIgnoreUnauthorizedForPath(path, method) {
  if (path === "/api/v1/auth/login" && (method || "GET").toUpperCase() === "POST") {
    return true;
  }
  return false;
}

function responseIsUnauthorized(res, data) {
  if (res.status === 401) return true;
  if (data && typeof data === "object") {
    if (data.statusCode === 401) return true;
    if (data.error?.statusCode === 401) return true;
  }
  return false;
}

export async function fetcher(options) {
  let url = appConfig.API_HOST + options.path;
  let body;

  const headers = {};
  const token = localStorage.getItem("token"); // Replace with actual token retrieval logic

  if (token) {
    headers["Authorization"] = `Bearer ${token}`;
  } else {
    console.log("Missing token");
  }

  if (options.params) {
    url += buildQueryString(options.params);
  }

  if (options?.pathIncluded) {
    const item = options?.pathIncluded;
    if (!!item) {
      let temp = `${appConfig.API_HOST + options?.path}`;
      Object.keys(item)?.forEach((val, _) => {
        temp = temp?.replace(val, options?.pathIncluded[val]);
      });
      url = temp;
    }
  }

  if (options?.body) {
    if (options.body instanceof FormData) {
      body = options.body;
    } else {
      body = JSON.stringify(options.body);
      headers["Content-Type"] = "application/json";
    }
  }

  try {
    const res = await fetch(url, {
      method: options?.method || "GET",
      headers: {
        ...headers,
        ...options?.headers,
      },
      body,
    });
    // const text = await res.text();
    let data;
    const contentType = res.headers.get("content-type");

    if (contentType && contentType.includes("application/json")) {
      data = await res.json();
    } else {
      data = await res.text(); // Could be HTML or plain text
    }

    if (!res.ok || data.success === false) {
      if (
        responseIsUnauthorized(res, data) &&
        !shouldIgnoreUnauthorizedForPath(options?.path, options?.method)
      ) {
        logoutExpiredSession();
      }
      // console.error(
      //   "API Error:",
      //   data.error || { code: res.status, message: res.statusText },
      // );
      handleError(data.error || { message: "Unknown error" });
      return {
        success: false,
        error: data.error || { message: "Unknown error" },
        statusCode: res.status,
      };
    }
    return data; // Return parsed data if successful
  } catch (error) {
    // console.error("Fetch error:", error.message || error);
    handleError(error);
    return { success: false, error: error.message || "Unknown error" };
  }
}

function handleError(error) {
  if (error && error.message) {
    console.log("Error:", error.message);
  } else {
    console.log("Unknown error occurred");
  }
}
